import { gameState } from '../util/game_state'

up.compiler('[game]', () => {
  gameState.startGame()
})
